import React from 'react';
import './staticContent.less';
import Heading from '../common/Heading';
import StaticHeader from '../StaticHeader';

const TermsOfUse = () => {
  return (
    <>
      <StaticHeader />
      <div className="staticBoxMain">
        <div className="statiContentBox">
          <Heading title="Terms & Conditions" className="staticMainTitle text-center mb-50" />
          <div className="staticContentWrapper">
            <Heading title="Terms and Conditions (T&C)" className="popupInnerTitle" />
            <div className="staticList">
              <ul>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
              </ul>
            </div>
          </div>
          <div className="staticContentWrapper">
            <Heading title="Terms of Service" className="popupInnerTitle" />
            <div className="staticList">
              <ul>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,
                </li>
                <li>First Come First Serve basis is used for online purchasing.</li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,
                </li>
                <li>
                  The company will verify details once it receives an order from the client, and if all conditions are
                  met, only then will the order be processed.
                </li>
                <li>
                  Courier agents will cover door to door insurance. The company reserves the right to refuse shipments
                  to certain international destinations.
                </li>
                <ul>
                  <p>
                    <b>Lorem Ipsum is simply dummy text of the printing and typesetting industry:</b>
                  </p>
                  <li>Lorem Ipsum is simply</li>
                  <li>Lorem Ipsum is simply</li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
